import ImagePageWrapper from "components/pages/ImagePageWrapper";
import { TermsAndConditions } from "features/TermsAndConditions";
import React from "react";

const TermsAndConditionsPage = () => {
  return (
    <ImagePageWrapper title="Terms of Contract">
      <TermsAndConditions />
    </ImagePageWrapper>
  );
};

export default TermsAndConditionsPage;
